import React from 'react';
import type {
  MoneyV2,
  ProductVariant,
} from '@shopify/hydrogen/storefront-api-types';
import {isDiscounted} from '~/lib/utils';
import clsx from 'clsx';
import {useMatches} from '@remix-run/react';

//domains
import type {SanityProductQueryResponse} from '~/domains/product';
import {CurrencySettingsGlobal, formatCurrency} from 'domains/currency';

export default function ProductDetailsPrices({
  selectedVariant,
}: {
  selectedVariant: ProductVariant;
}) {
  const matches = useMatches();
  const routeData = matches.find(
    (m) => m.id === 'routes/($lang)/products/$productHandle',
  )?.data;
  const productSettings =
    routeData.productSettings as SanityProductQueryResponse['productSettings'];
  return (
    <div className="price mt-3 flex space-x-1 lg:mt-[20px] ">
      <span className="font-medium">
        {productSettings?.product_settings_translations?.price_label ?? 'Price'}{' '}
        :
      </span>
      <ProductPrices
        price={selectedVariant.price}
        compareAtPrice={selectedVariant.compareAtPrice ?? undefined}
        type="shopify"
      />
    </div>
  );
}

function ProductPrices({
  price,
  compareAtPrice,
  type = 'shopify',
}: {
  price: MoneyV2;
  compareAtPrice?: MoneyV2;
  type: 'shopify' | 'bfs';
}) {
  const [root] = useMatches();
  const currency = root.data.currency as CurrencySettingsGlobal;

  if (type === 'shopify') {
    const priceFormatted = formatCurrency({price, currency});
    const compareAtPriceFormatted =
      isDiscounted(price as MoneyV2, compareAtPrice as MoneyV2) &&
      compareAtPrice &&
      formatCurrency({price: compareAtPrice, currency});

    return (
      <div className="flex justify-center font-bold">
        {compareAtPriceFormatted ? (
          <span className="mr-1 font-normal text-darkGray line-through decoration-red md:mr-3">
            {compareAtPriceFormatted.currencyCode}
            {compareAtPriceFormatted.amount.toFixed(2)}
          </span>
        ) : null}
        <span className={clsx('font-bold text-hk-orange')}>
          {priceFormatted?.currencyCode}
          {priceFormatted?.amount.toFixed(2)}
        </span>
      </div>
    );
  }

  return <></>;
}
